import { createFileRoute } from "@tanstack/react-router";
import { ExplorePage } from "../../../features/activities/pages/explore-page";
import {
  activitiesQueryOptions,
  buildActivityFilters,
  type ActivityRouteSearch,
} from "../../../features/activities/api/activities-query";
import { categoriesQueryOptions } from "../../../features/activities/hooks/use-categories";
import { citiesQueryOptions } from "../../../features/activities/hooks/use-cities";

export const Route = createFileRoute("/$lang/_layout/explore/")({
  // See place.$city.tsx — prefetch so navigation keeps the old page visible
  // rather than flashing the full-page Suspense spinner.
  loaderDeps: ({ search }: { search: ActivityRouteSearch }) => ({
    q: search.q,
    page: search.page,
    min_price: search.min_price,
    max_price: search.max_price,
    sort: search.sort,
  }),
  loader: async ({ context, params, deps }) => {
    const filters = buildActivityFilters(params, deps);
    await Promise.all([
      context.queryClient.ensureQueryData(activitiesQueryOptions(filters)),
      // The cross-links read these to link only hubs with something in them.
      context.queryClient.ensureQueryData(categoriesQueryOptions(undefined, params.lang)),
      context.queryClient.ensureQueryData(citiesQueryOptions(params.lang)),
    ]);
  },
  component: ExplorePage,
});
